module.exports = __webpack_public_path__ + "components/flag/static/square/au-340ca016d3e9806104011a94322684ba.svg";